/**
* DevExpress Analytics (property-grid\widgets\internal\_extendedSvgTemplates.js)
* Version:  21.2.13
* Build date: Apr 10, 2023
* Copyright (c) 2012 - 2023 Developer Express Inc. ALL RIGHTS RESERVED
* License: https://www.devexpress.com/Support/EULAs/universal.xml
*/
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.extendedTemplates = function (templates) { return ({
    'dxrd-svg-fieldlist-list': templates['dxrd-svg-fieldlist-table'],
    'dxrd-svg-fieldlist-default': templates['dxrd-svg-fieldlist-column']
}); };
